/**
 * Tabs of the service request flags modal.
 */
export enum ServiceRequestFlagTabEnum {
  Active = 'Active',
  Resolved = 'Resolved',
}
